import { redirect } from '@tanstack/react-router';

import { CODE_CHALLENGE_METHOD, preparePkceChallenge } from '@@auth/utils/pkce';
import { resolveAuthenticationApiUrl } from '@@config';

/**
 * The URL that starts the OAuth2 authorization code flow with PKCE (RFC 7636).
 */
const getLoginUrl = async (apiEnv?: string) => {
    const codeChallenge = await preparePkceChallenge();

    const challengeParams = new URLSearchParams({
        code_challenge: codeChallenge,
        code_challenge_method: CODE_CHALLENGE_METHOD,
    });

    return `${resolveAuthenticationApiUrl(apiEnv)}&${challengeParams}`;
};

/**
 * The redirect a route guard throws to start the login. It loads the login provider's page even
 * when the provider shares the app's host, where the router would look for an app page instead.
 */
export const getLoginRedirect = async () =>
    redirect({ href: await getLoginUrl(), reloadDocument: true });

/**
 * Starts the OAuth2 authorization code flow with PKCE (RFC 7636).
 */
export const login = async (apiEnv?: string) => {
    window.location.assign(await getLoginUrl(apiEnv));
};
